import { isDev } from '@/Utils';
/** Align rpId with the page hostname for local WebAuthn development. */
export function prepareWebAuthnRegistrationOptions(options) {
    if (!isDev) {
        return options;
    }
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
        return options;
    }
    const rp = options.rp;
    if (!rp) {
        return options;
    }
    return {
        ...options,
        rp: {
            ...rp,
            id: hostname,
        },
    };
}
